<fc-search-input
  #fcSearchInput
  [label]="'COMPANY.LABEL' | translate"
  [control]="control"
  [search]="search"
  [displayText]="displayText"
  [displayWith]="displayWith"
  [sortOptionsFn]="sortCompanies.bind(this)"
  [showSearchIcon]="showSearchIcon"
  [requiredMark]="requiredMark"
  [preloadOptions]="preloadOptions"
  [searchOnFocus]="searchOnFocus"
></fc-search-input>
